import { Pipe, PipeTransform, inject } from '@angular/core';
import {FormatEuroCentsDirective} from '../directives/format-euro-cents.directive';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
    name: 'priceFormat',
    standalone: false
})
export class PriceFormatPipe implements PipeTransform {
    private translateService = inject(TranslateService);


    transform(value: string | number = '') {
        const numberValue = FormatEuroCentsDirective.convertToNumber(value);
        const formattedEuro = FormatEuroCentsDirective.convertNumberToEuros(numberValue, this.translateService.getFallbackLang());

        return formattedEuro;
    }

}
